import { makeStyles } from '@material-ui/core';
import { Image } from 'antd';
import { FC } from 'react';
import InnerHeader from 'src/component/InnerHeader';

const useStyles = makeStyles({
  body: {
    display: 'flex',
    gap: '50px',
    paddingLeft: '35px'
  },
  gridItem: {
    maxWidth: '90%',
    textAlign: 'start'
  },
  p: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%'
  },
  span: {
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500
  }
});
interface VerificationsProps {
  bankAccount: string;
  idPicture?: string;
}

const Verifications: FC<VerificationsProps> = ({ bankAccount, idPicture }) => {
  const classes = useStyles();
  return (
    <div>
      <div
        style={{
          marginTop: '80px',
          overflowY: 'auto'
        }}
      >
        <InnerHeader subtitle="" title="Verification" />
        <div className={classes.body}>
          <Image
            height={52}
            src={idPicture || 'https://placehold.co/640x480'}
            style={{ objectFit: 'contain' }}
          />
          <div className={classes.gridItem}>
            <p className={classes.p}>Bank Account</p>
            <span className={classes.span}>{bankAccount}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verifications;
